var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetshoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8059 0H5.19259C2.32513 0 0 2.32513 0 5.19259V22.8074C0 25.6749 2.32513 28 5.19259 28H22.8074C25.6749 28 28 25.6749 28 22.8074V5.19259C27.9985 2.32513 25.6734 0 22.8059 0Z",
    fill: "#4D296C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.799 10.484C11.7821 10.251 11.7213 10.1464 11.4614 10.1464C11.2014 10.1464 11.1238 10.2443 11.0765 10.484L8.86866 18.8799C8.48381 20.3619 7.96054 20.8852 6.34009 20.8852H5.4117C5.02685 20.8852 4.92895 20.6725 5.0471 20.2674L7.86263 9.93031C8.40278 7.92501 9.32779 7 12.0285 7C13.8785 7 14.7293 7.4625 14.8812 9.89318L15.364 17.5295C15.3842 17.7591 15.4214 17.8671 15.6712 17.8671C15.921 17.8671 16.0088 17.7726 16.0594 17.5295L18.2403 9.13359C18.6251 7.64818 19.1248 7.12829 20.7452 7.12829H21.6905C22.0753 7.12829 22.1732 7.34097 22.0584 7.74271L19.253 18.0697C18.7129 20.075 17.8048 21 15.1276 21C13.2337 21 12.3493 20.5375 12.2142 18.1068L11.799 10.484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetshoes);
export default __webpack_public_path__ + "static/media/netshoes.6a9c15f75afec75bce284c6b59c4b460.svg";
export { ForwardRef as ReactComponent };